module.exports = __webpack_public_path__ + "img/p2-4.3f5d97bf.png";